// This file is auto-generated by @hey-api/openapi-ts

export {
  apiSchemaRetrieve,
  backgroundTasksTasksRetrieve,
  directoutreachBetanxtVoterPolicySnapshotExportCreate,
  directoutreachPolicyAvailableList,
  directoutreachPolicyAvailableRetrieve,
  directoutreachPolicyCreate,
  directoutreachVotersBatchCreateCreate,
  directoutreachVotersCreateCreate,
  directoutreachVotersHoldingsRetrieve,
  directoutreachVotersRetrieve,
  directoutreachVotersSelectedPolicyCreate,
  directoutreachVotersSelectedPolicyRetrieve,
  fundManagerFundManagersCreate,
  fundManagerFundManagersList,
  fundManagerFundManagersRetrieve,
  fundManagerFundManagersUpdate,
  fundManagerProvidersCreate,
  fundManagerProvidersList,
  fundManagerProvidersRetrieve,
  fundManagerProvidersUpdate,
  institutionalMeetingsearchList,
  type Options,
  proxyvotingEntitlementsBreakdownCreate,
  proxyvotingEntitlementsComputeCreate,
  proxyvotingEntitlementsList,
  proxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreate,
  proxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreate,
  proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreate,
  proxyvotingFundManagerPolicySupportedIssuedInstrumentsList,
  proxyvotingFundManagerSupportedPoliciesCreate,
  proxyvotingFundManagerSupportedPoliciesDestroy,
  proxyvotingFundManagerSupportedPoliciesList,
  proxyvotingInvestorCompositionsDifferenceList,
  proxyvotingInvestorCompositionsRenderCreate,
  proxyvotingInvestorCompositionsRulesEngineRetrieve,
  proxyvotingInvestorCompositionsRulesEngineUpdate,
  proxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreate,
  proxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreate,
  proxyvotingInvestorPolicySupportedIssuedInstrumentsCreate,
  proxyvotingInvestorPolicySupportedIssuedInstrumentsList,
  proxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreate,
  proxyvotingInvestorSupportedIssuedInstrumentsCreate,
  proxyvotingInvestorSupportedIssuedInstrumentsList,
  proxyvotingInvestorSupportedIssuedInstrumentsSearchCreate,
  proxyvotingMeetingballotsComputeCreate,
  proxyvotingMeetingBallotsList,
  proxyvotingMeetingBallotSourcesList,
  proxyvotingPiballotsFilterList,
  proxyvotingPiballotsInvestorsCanVoteCreate,
  proxyvotingPimeetingsFilterList,
  proxyvotingRulesEngineDefinitionsByNameDestroy,
  proxyvotingRulesEngineDefinitionsCreate,
  proxyvotingRulesEngineDefinitionsDestroy,
  proxyvotingRulesEngineDefinitionsList,
  proxyvotingRulesEngineDefinitionsNamesRetrieve,
  proxyvotingRulesEngineDefinitionsRetrieve,
  proxyvotingRulesEngineDefinitionsRulesCreate,
  proxyvotingRulesEngineDefinitionsRulesDestroy,
  proxyvotingRulesEngineDefinitionsRulesList,
  proxyvotingRulesEngineDefinitionsRulesUpdate,
  proxyvotingSviProposalOverwriteCreate,
  proxyvotingSviProposalOverwriteReasonsList,
  transparencyAuditEventsList,
  transparencyAuditEventsSearchCreate,
  transparencyExternalMeetingIdsCreate,
  transparencyExternalMeetingIdsDestroy,
  transparencyInstrumentsCreate,
  transparencyInstrumentsDestroy,
  transparencyInstrumentsFetchMinimalCreate,
  transparencyInstrumentsList,
  transparencyInstrumentsRetrieve,
  transparencyInstrumentsUnassociatedRetrieve,
  transparencyInstrumentsUpdate,
  transparencyOrganizationsCreate,
  transparencyOrganizationsDestroy,
  transparencyOrganizationsGetByIdentifierCreate,
  transparencyOrganizationsIsinsToNamesCreate,
  transparencyOrganizationsList,
  transparencyOrganizationsLogoCreate,
  transparencyOrganizationsPartialUpdate,
  transparencyOrganizationsRetrieve,
  transparencyOrganizationsSearchCreate,
  transparencyOrganizationsUpdate,
  transparencyPublicSecurityIdsList,
  transparencyPublicSecurityIdsSearchCreate,
  votingOperationsPiballotsFilterList,
  votingOperationsPimeetingsFilterList,
  votingPolicyProviderVotingRecommendationsCreate,
  votingPolicyProviderVotingRecommendationsDestroy,
  votingPolicyProviderVotingRecommendationsFetchByVersionRetrieve,
  votingPolicyProviderVotingRecommendationsSearchCreate,
  votingPolicyVotingPoliciesDocumentsCreate,
  votingPolicyVotingPoliciesDocumentsList,
  votingPolicyVotingPoliciesDocumentsPartialUpdate,
  votingPolicyVotingPoliciesDocumentsRetrieve,
  votingPolicyVotingPoliciesVotingRecommendationsCreate,
  votingPolicyVotingPoliciesVotingRecommendationsDestroy,
  votingPolicyVotingPoliciesVotingRecommendationsList,
  votingPolicyVotingPoliciesVotingRecommendationsPartialUpdate,
  votingPolicyVotingPoliciesVotingRecommendationsRetrieve,
  votingPolicyVotingRecommendationConfidenceScoresUpdate,
} from './sdk.gen'
export {
  type ApiSchemaRetrieveData,
  type ApiSchemaRetrieveResponse,
  type ApiSchemaRetrieveResponses,
  type AuditEvent,
  type AuditEventSearchRequestRequest,
  type BackgroundTasksTasksRetrieveData,
  type BackgroundTasksTasksRetrieveErrors,
  type BackgroundTasksTasksRetrieveResponse,
  type BackgroundTasksTasksRetrieveResponses,
  type BallotEntitlement,
  type BallotEntitlementWritable,
  type BallotInvestorsCanVote,
  type BatchIsinsToOrganizationNamesRequestRequest,
  type BatchIsinsToOrganizationNamesResponse,
  type BatchVoterWithHoldingsInputRequest,
  type BatchVoterWithHoldingsResponse,
  type BatchVoterWithHoldingsResponseWritable,
  BioSourceEnum,
  type BreakdownResponse,
  type ClientOptions,
  type ComponentDiff,
  type ComponentDiffRequest,
  type CompositionDifferenceResponse,
  type ComputeBreakdownRequestRequest,
  DiffFormatEnum,
  type DirectoutreachBetanxtVoterPolicySnapshotExportCreateData,
  type DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponse,
  type DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses,
  type DirectoutreachPolicyAvailableListData,
  type DirectoutreachPolicyAvailableListResponse,
  type DirectoutreachPolicyAvailableListResponses,
  type DirectoutreachPolicyAvailableRetrieveData,
  type DirectoutreachPolicyAvailableRetrieveResponse,
  type DirectoutreachPolicyAvailableRetrieveResponses,
  type DirectoutreachPolicyCreateData,
  type DirectoutreachPolicyCreateResponse,
  type DirectoutreachPolicyCreateResponses,
  type DirectoutreachVotersBatchCreateCreateData,
  type DirectoutreachVotersBatchCreateCreateErrors,
  type DirectoutreachVotersBatchCreateCreateResponse,
  type DirectoutreachVotersBatchCreateCreateResponses,
  type DirectoutreachVotersCreateCreateData,
  type DirectoutreachVotersCreateCreateResponse,
  type DirectoutreachVotersCreateCreateResponses,
  type DirectoutreachVotersHoldingsRetrieveData,
  type DirectoutreachVotersHoldingsRetrieveErrors,
  type DirectoutreachVotersHoldingsRetrieveResponse,
  type DirectoutreachVotersHoldingsRetrieveResponses,
  type DirectoutreachVotersRetrieveData,
  type DirectoutreachVotersRetrieveErrors,
  type DirectoutreachVotersRetrieveResponse,
  type DirectoutreachVotersRetrieveResponses,
  type DirectoutreachVotersSelectedPolicyCreateData,
  type DirectoutreachVotersSelectedPolicyCreateErrors,
  type DirectoutreachVotersSelectedPolicyCreateResponse,
  type DirectoutreachVotersSelectedPolicyCreateResponses,
  type DirectoutreachVotersSelectedPolicyRetrieveData,
  type DirectoutreachVotersSelectedPolicyRetrieveErrors,
  type DirectoutreachVotersSelectedPolicyRetrieveResponse,
  type DirectoutreachVotersSelectedPolicyRetrieveResponses,
  type ExportResult,
  type ExternalMeetingId,
  type ExternalMeetingIdCreateRequest,
  type FetchMinimalInstrumentsRequestRequest,
  type FetchMinimalInstrumentsResponse,
  type FetchMinimalInstrumentsResponseWritable,
  FilterReasonsEnum,
  type FundManager,
  type FundManagerFundManagersCreateData,
  type FundManagerFundManagersCreateResponse,
  type FundManagerFundManagersCreateResponses,
  type FundManagerFundManagersListData,
  type FundManagerFundManagersListResponse,
  type FundManagerFundManagersListResponses,
  type FundManagerFundManagersRetrieveData,
  type FundManagerFundManagersRetrieveResponse,
  type FundManagerFundManagersRetrieveResponses,
  type FundManagerFundManagersUpdateData,
  type FundManagerFundManagersUpdateResponse,
  type FundManagerFundManagersUpdateResponses,
  type FundManagerPolicySii,
  type FundManagerPolicySiiBatchCreateRequest,
  type FundManagerPolicySiiBatchDeleteRequest,
  type FundManagerPolicySiiInputRequest,
  type FundManagerPolicySiiResponse,
  type FundManagerPolicySiiResponseWritable,
  type FundManagerPolicySiiWritable,
  type FundManagerProvidersCreateData,
  type FundManagerProvidersCreateResponse,
  type FundManagerProvidersCreateResponses,
  type FundManagerProvidersListData,
  type FundManagerProvidersListResponse,
  type FundManagerProvidersListResponses,
  type FundManagerProvidersRetrieveData,
  type FundManagerProvidersRetrieveResponse,
  type FundManagerProvidersRetrieveResponses,
  type FundManagerProvidersUpdateData,
  type FundManagerProvidersUpdateResponse,
  type FundManagerProvidersUpdateResponses,
  type FundManagerSupportedIssuedInstrumentsQueryRequest,
  type FundManagerSupportedVotingPolicy,
  type FundManagerSupportedVotingPolicyBatchUpsertRequest,
  type FundManagerSupportedVotingPolicyBatchUpsertResponse,
  type FundManagerSupportedVotingPolicyBatchUpsertResponseWritable,
  type FundManagerSupportedVotingPolicyHistorical,
  type FundManagerSupportedVotingPolicyItemRequest,
  type FundManagerWritable,
  type FundManagerWriteRequest,
  type GetOrganizationByIdentifierRequestRequest,
  type Holding,
  type HoldingInputRequest,
  type HoldingResponse,
  type HoldingResponseWritable,
  type HoldingWritable,
  IdentifierTypeEnum,
  type Industry,
  type IndustryNaics,
  type IndustryNaicsRequest,
  type IndustryNaicsWritable,
  type IndustryRequest,
  type IndustryWritable,
  type InstitutionalMeetingsearchListData,
  type InstitutionalMeetingsearchListResponse,
  type InstitutionalMeetingsearchListResponses,
  type Instrument,
  type InstrumentWritable,
  type InstrumentWriteRequest,
  type InvestorAccountVoteInfo,
  type InvestorPolicySii,
  type InvestorPolicySiiBatchCreateRequest,
  type InvestorPolicySiiBatchDeleteRequest,
  type InvestorPolicySiiInputRequest,
  type InvestorPolicySiiResponse,
  type InvestorPolicySiiResponseWritable,
  type InvestorPolicySiiWritable,
  type InvestorRulesEngine,
  type InvestorRulesEngineRequest,
  type InvestorRulesEngineWritable,
  type InvestorsCanVoteRequest,
  type InvestorsCanVoteResponse,
  type InvestorSiiBatchCreateRequest,
  type InvestorSiiBatchDeleteRequest,
  type InvestorSiiInputRequest,
  type InvestorSiiResponse,
  type InvestorSiiResponseWritable,
  type InvestorSiiSearchRequestRequest,
  type InvestorSupportedIssuedInstrument,
  type InvestorSupportedIssuedInstrumentWritable,
  InvestorTypeEnum,
  type Meeting,
  type MeetingBallot,
  type MeetingBallotSource,
  type MeetingBallotSourceWritable,
  type MeetingBallotWritable,
  MeetingTypeEnum,
  type MeetingWritable,
  type MinimalInstrument,
  type MinimalInstrumentWritable,
  type Organization,
  type OrganizationAddress,
  type OrganizationAddressRequest,
  type OrganizationBio,
  type OrganizationBioRequest,
  type OrganizationIdentifier,
  type OrganizationIdentifierRequest,
  type OrganizationLogoUploadRequest,
  type OrganizationSearchRequestRequest,
  type OrganizationWritable,
  type OrganizationWriteRequest,
  type PaginatedAuditEventList,
  type PaginatedAuditEventListWritable,
  type PaginatedBallotEntitlementList,
  type PaginatedBallotEntitlementListWritable,
  type PaginatedFundManagerList,
  type PaginatedFundManagerListWritable,
  type PaginatedFundManagerPolicySiiList,
  type PaginatedFundManagerPolicySiiListWritable,
  type PaginatedFundManagerSupportedVotingPolicyHistoricalList,
  type PaginatedInstrumentList,
  type PaginatedInstrumentListWritable,
  type PaginatedInvestorPolicySiiList,
  type PaginatedInvestorPolicySiiListWritable,
  type PaginatedInvestorSupportedIssuedInstrumentList,
  type PaginatedInvestorSupportedIssuedInstrumentListWritable,
  type PaginatedMeetingBallotList,
  type PaginatedMeetingBallotListWritable,
  type PaginatedMeetingBallotSourceList,
  type PaginatedMeetingBallotSourceListWritable,
  type PaginatedMeetingList,
  type PaginatedMeetingListWritable,
  type PaginatedOrganizationList,
  type PaginatedOrganizationListWritable,
  type PaginatedPiBallotSearchList,
  type PaginatedPiBallotSearchListWritable,
  type PaginatedPiMeetingSearchList,
  type PaginatedPiMeetingSearchListWritable,
  type PaginatedProviderList,
  type PaginatedProviderListWritable,
  type PaginatedProviderVotingRecommendationList,
  type PaginatedPublicSecurityIdList,
  type PaginatedPublicSecurityIdListWritable,
  type PaginatedRulesEngineDefinitionList,
  type PaginatedRulesEngineDefinitionListWritable,
  type PaginatedRulesEngineRuleList,
  type PaginatedRulesEngineRuleListWritable,
  type PaginatedSplitVoteInstructionOverwriteReasonList,
  type PaginatedVotingPolicyDocumentList,
  type PaginatedVotingPolicyDocumentListWritable,
  type PaginatedVotingRecommendationList,
  type PaginatedVotingRecommendationListWritable,
  type PatchedOrganizationWriteRequest,
  type PatchedVotingPolicyDocumentUpdateRequest,
  type PatchedVotingRecommendationUpdateRequest,
  type PiBallotSearch,
  type PiBallotSearchWritable,
  type PiMeetingSearch,
  type PiMeetingSearchWritable,
  type Policy,
  PolicyInstructionEnum,
  type PolicyRequest,
  type PolicyResponse,
  type PolicyResponseWritable,
  type PolicyWritable,
  type Provider,
  type ProviderVotingRecommendation,
  type ProviderVotingRecommendationCreateRequest,
  type ProviderVotingRecommendationListResponse,
  type ProviderVotingRecommendationSearchRequest,
  type ProviderWritable,
  type ProviderWriteRequest,
  type ProxyvotingEntitlementsBreakdownCreateData,
  type ProxyvotingEntitlementsBreakdownCreateResponse,
  type ProxyvotingEntitlementsBreakdownCreateResponses,
  type ProxyvotingEntitlementsComputeCreateData,
  type ProxyvotingEntitlementsComputeCreateResponse,
  type ProxyvotingEntitlementsComputeCreateResponses,
  type ProxyvotingEntitlementsListData,
  type ProxyvotingEntitlementsListResponse,
  type ProxyvotingEntitlementsListResponses,
  type ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateData,
  type ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateResponses,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateData,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponse,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateData,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponse,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsListData,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsListResponse,
  type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsListResponses,
  type ProxyvotingFundManagerSupportedPoliciesCreateData,
  type ProxyvotingFundManagerSupportedPoliciesCreateResponse,
  type ProxyvotingFundManagerSupportedPoliciesCreateResponses,
  type ProxyvotingFundManagerSupportedPoliciesDestroyData,
  type ProxyvotingFundManagerSupportedPoliciesDestroyResponse,
  type ProxyvotingFundManagerSupportedPoliciesDestroyResponses,
  type ProxyvotingFundManagerSupportedPoliciesListData,
  type ProxyvotingFundManagerSupportedPoliciesListResponse,
  type ProxyvotingFundManagerSupportedPoliciesListResponses,
  type ProxyvotingInvestorCompositionsDifferenceListData,
  type ProxyvotingInvestorCompositionsDifferenceListResponse,
  type ProxyvotingInvestorCompositionsDifferenceListResponses,
  type ProxyvotingInvestorCompositionsRenderCreateData,
  type ProxyvotingInvestorCompositionsRenderCreateResponse,
  type ProxyvotingInvestorCompositionsRenderCreateResponses,
  type ProxyvotingInvestorCompositionsRulesEngineRetrieveData,
  type ProxyvotingInvestorCompositionsRulesEngineRetrieveResponse,
  type ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses,
  type ProxyvotingInvestorCompositionsRulesEngineUpdateData,
  type ProxyvotingInvestorCompositionsRulesEngineUpdateResponse,
  type ProxyvotingInvestorCompositionsRulesEngineUpdateResponses,
  type ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateData,
  type ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateResponses,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateData,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponse,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateData,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponse,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsListData,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsListResponse,
  type ProxyvotingInvestorPolicySupportedIssuedInstrumentsListResponses,
  type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateData,
  type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponse,
  type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses,
  type ProxyvotingInvestorSupportedIssuedInstrumentsCreateData,
  type ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponse,
  type ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses,
  type ProxyvotingInvestorSupportedIssuedInstrumentsListData,
  type ProxyvotingInvestorSupportedIssuedInstrumentsListResponse,
  type ProxyvotingInvestorSupportedIssuedInstrumentsListResponses,
  type ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateData,
  type ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponse,
  type ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponses,
  type ProxyvotingMeetingballotsComputeCreateData,
  type ProxyvotingMeetingballotsComputeCreateResponse,
  type ProxyvotingMeetingballotsComputeCreateResponses,
  type ProxyvotingMeetingBallotsListData,
  type ProxyvotingMeetingBallotsListResponse,
  type ProxyvotingMeetingBallotsListResponses,
  type ProxyvotingMeetingBallotSourcesListData,
  type ProxyvotingMeetingBallotSourcesListResponse,
  type ProxyvotingMeetingBallotSourcesListResponses,
  type ProxyvotingPiballotsFilterListData,
  type ProxyvotingPiballotsFilterListResponse,
  type ProxyvotingPiballotsFilterListResponses,
  type ProxyvotingPiballotsInvestorsCanVoteCreateData,
  type ProxyvotingPiballotsInvestorsCanVoteCreateResponse,
  type ProxyvotingPiballotsInvestorsCanVoteCreateResponses,
  type ProxyvotingPimeetingsFilterListData,
  type ProxyvotingPimeetingsFilterListResponse,
  type ProxyvotingPimeetingsFilterListResponses,
  type ProxyvotingRulesEngineDefinitionsByNameDestroyData,
  type ProxyvotingRulesEngineDefinitionsByNameDestroyErrors,
  type ProxyvotingRulesEngineDefinitionsByNameDestroyResponse,
  type ProxyvotingRulesEngineDefinitionsByNameDestroyResponses,
  type ProxyvotingRulesEngineDefinitionsCreateData,
  type ProxyvotingRulesEngineDefinitionsCreateResponse,
  type ProxyvotingRulesEngineDefinitionsCreateResponses,
  type ProxyvotingRulesEngineDefinitionsDestroyData,
  type ProxyvotingRulesEngineDefinitionsDestroyErrors,
  type ProxyvotingRulesEngineDefinitionsDestroyResponse,
  type ProxyvotingRulesEngineDefinitionsDestroyResponses,
  type ProxyvotingRulesEngineDefinitionsListData,
  type ProxyvotingRulesEngineDefinitionsListResponse,
  type ProxyvotingRulesEngineDefinitionsListResponses,
  type ProxyvotingRulesEngineDefinitionsNamesRetrieveData,
  type ProxyvotingRulesEngineDefinitionsNamesRetrieveResponse,
  type ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses,
  type ProxyvotingRulesEngineDefinitionsRetrieveData,
  type ProxyvotingRulesEngineDefinitionsRetrieveResponse,
  type ProxyvotingRulesEngineDefinitionsRetrieveResponses,
  type ProxyvotingRulesEngineDefinitionsRulesCreateData,
  type ProxyvotingRulesEngineDefinitionsRulesCreateResponse,
  type ProxyvotingRulesEngineDefinitionsRulesCreateResponses,
  type ProxyvotingRulesEngineDefinitionsRulesDestroyData,
  type ProxyvotingRulesEngineDefinitionsRulesDestroyResponse,
  type ProxyvotingRulesEngineDefinitionsRulesDestroyResponses,
  type ProxyvotingRulesEngineDefinitionsRulesListData,
  type ProxyvotingRulesEngineDefinitionsRulesListResponse,
  type ProxyvotingRulesEngineDefinitionsRulesListResponses,
  type ProxyvotingRulesEngineDefinitionsRulesUpdateData,
  type ProxyvotingRulesEngineDefinitionsRulesUpdateResponse,
  type ProxyvotingRulesEngineDefinitionsRulesUpdateResponses,
  type ProxyvotingSviProposalOverwriteCreateData,
  type ProxyvotingSviProposalOverwriteCreateResponse,
  type ProxyvotingSviProposalOverwriteCreateResponses,
  type ProxyvotingSviProposalOverwriteReasonsListData,
  type ProxyvotingSviProposalOverwriteReasonsListResponse,
  type ProxyvotingSviProposalOverwriteReasonsListResponses,
  type PublicSecurityId,
  type PublicSecurityIdListQueryRequest,
  type PublicSecurityIdWritable,
  type RenderCompositionDifferenceRequest,
  ReportableReasonEnum,
  type RulesEngineDefinition,
  type RulesEngineDefinitionCreateRequest,
  type RulesEngineDefinitionWritable,
  type RulesEngineNamesResponse,
  type RulesEngineRule,
  type RulesEngineRuleWritable,
  type RulesEngineRuleWriteRequest,
  RuleTypeEnum,
  type SelectedPolicy,
  type SelectedPolicyRequestRequest,
  type SelectedPolicyResponse,
  type SelectedPolicyResponseWritable,
  type SelectedPolicyWritable,
  type SplitVoteInstructionOverwriteReason,
  type SplitVoteInstructionProposalOverwrite,
  type SplitVoteInstructionProposalOverwriteRequest,
  type SplitVoteInstructionProposalOverwriteWritable,
  StatusEnum,
  type SupportedIssuedInstrumentsQueryRequest,
  type TaskStatus,
  type TaskTriggered,
  type TransparencyAuditEventsListData,
  type TransparencyAuditEventsListResponse,
  type TransparencyAuditEventsListResponses,
  type TransparencyAuditEventsSearchCreateData,
  type TransparencyAuditEventsSearchCreateResponse,
  type TransparencyAuditEventsSearchCreateResponses,
  type TransparencyExternalMeetingIdsCreateData,
  type TransparencyExternalMeetingIdsCreateResponse,
  type TransparencyExternalMeetingIdsCreateResponses,
  type TransparencyExternalMeetingIdsDestroyData,
  type TransparencyExternalMeetingIdsDestroyResponse,
  type TransparencyExternalMeetingIdsDestroyResponses,
  type TransparencyInstrumentsCreateData,
  type TransparencyInstrumentsCreateResponse,
  type TransparencyInstrumentsCreateResponses,
  type TransparencyInstrumentsDestroyData,
  type TransparencyInstrumentsDestroyResponse,
  type TransparencyInstrumentsDestroyResponses,
  type TransparencyInstrumentsFetchMinimalCreateData,
  type TransparencyInstrumentsFetchMinimalCreateResponse,
  type TransparencyInstrumentsFetchMinimalCreateResponses,
  type TransparencyInstrumentsListData,
  type TransparencyInstrumentsListResponse,
  type TransparencyInstrumentsListResponses,
  type TransparencyInstrumentsRetrieveData,
  type TransparencyInstrumentsRetrieveResponse,
  type TransparencyInstrumentsRetrieveResponses,
  type TransparencyInstrumentsUnassociatedRetrieveData,
  type TransparencyInstrumentsUnassociatedRetrieveResponse,
  type TransparencyInstrumentsUnassociatedRetrieveResponses,
  type TransparencyInstrumentsUpdateData,
  type TransparencyInstrumentsUpdateResponse,
  type TransparencyInstrumentsUpdateResponses,
  type TransparencyOrganizationsCreateData,
  type TransparencyOrganizationsCreateResponse,
  type TransparencyOrganizationsCreateResponses,
  type TransparencyOrganizationsDestroyData,
  type TransparencyOrganizationsDestroyResponse,
  type TransparencyOrganizationsDestroyResponses,
  type TransparencyOrganizationsGetByIdentifierCreateData,
  type TransparencyOrganizationsGetByIdentifierCreateResponse,
  type TransparencyOrganizationsGetByIdentifierCreateResponses,
  type TransparencyOrganizationsIsinsToNamesCreateData,
  type TransparencyOrganizationsIsinsToNamesCreateResponse,
  type TransparencyOrganizationsIsinsToNamesCreateResponses,
  type TransparencyOrganizationsListData,
  type TransparencyOrganizationsListResponse,
  type TransparencyOrganizationsListResponses,
  type TransparencyOrganizationsLogoCreateData,
  type TransparencyOrganizationsLogoCreateResponse,
  type TransparencyOrganizationsLogoCreateResponses,
  type TransparencyOrganizationsPartialUpdateData,
  type TransparencyOrganizationsPartialUpdateResponse,
  type TransparencyOrganizationsPartialUpdateResponses,
  type TransparencyOrganizationsRetrieveData,
  type TransparencyOrganizationsRetrieveResponse,
  type TransparencyOrganizationsRetrieveResponses,
  type TransparencyOrganizationsSearchCreateData,
  type TransparencyOrganizationsSearchCreateResponse,
  type TransparencyOrganizationsSearchCreateResponses,
  type TransparencyOrganizationsUpdateData,
  type TransparencyOrganizationsUpdateResponse,
  type TransparencyOrganizationsUpdateResponses,
  type TransparencyPublicSecurityIdsListData,
  type TransparencyPublicSecurityIdsListResponse,
  type TransparencyPublicSecurityIdsListResponses,
  type TransparencyPublicSecurityIdsSearchCreateData,
  type TransparencyPublicSecurityIdsSearchCreateResponse,
  type TransparencyPublicSecurityIdsSearchCreateResponses,
  type TriggerComputeEntitlementsRequest,
  type TriggerProcessMeetingBallotsRequest,
  TypeEnum,
  type UnassociatedInstrumentsResponse,
  type UnassociatedInstrumentsResponseWritable,
  type VoterDetailsResponse,
  type VoterResponse,
  type VoterResponseWritable,
  type VoterWithHoldingsInputRequest,
  type VoterWithHoldingsResponse,
  type VoterWithHoldingsResponseWritable,
  VotingInstructionEnum,
  type VotingOperationsPiballotsFilterListData,
  type VotingOperationsPiballotsFilterListResponse,
  type VotingOperationsPiballotsFilterListResponses,
  type VotingOperationsPimeetingsFilterListData,
  type VotingOperationsPimeetingsFilterListResponse,
  type VotingOperationsPimeetingsFilterListResponses,
  type VotingPolicyDocument,
  type VotingPolicyDocumentWritable,
  type VotingPolicyProviderVotingRecommendationsCreateData,
  type VotingPolicyProviderVotingRecommendationsCreateResponse,
  type VotingPolicyProviderVotingRecommendationsCreateResponses,
  type VotingPolicyProviderVotingRecommendationsDestroyData,
  type VotingPolicyProviderVotingRecommendationsDestroyResponse,
  type VotingPolicyProviderVotingRecommendationsDestroyResponses,
  type VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveData,
  type VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponse,
  type VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponses,
  type VotingPolicyProviderVotingRecommendationsSearchCreateData,
  type VotingPolicyProviderVotingRecommendationsSearchCreateResponse,
  type VotingPolicyProviderVotingRecommendationsSearchCreateResponses,
  type VotingPolicyVotingPoliciesDocumentsCreateData,
  type VotingPolicyVotingPoliciesDocumentsCreateResponse,
  type VotingPolicyVotingPoliciesDocumentsCreateResponses,
  type VotingPolicyVotingPoliciesDocumentsListData,
  type VotingPolicyVotingPoliciesDocumentsListResponse,
  type VotingPolicyVotingPoliciesDocumentsListResponses,
  type VotingPolicyVotingPoliciesDocumentsPartialUpdateData,
  type VotingPolicyVotingPoliciesDocumentsPartialUpdateResponse,
  type VotingPolicyVotingPoliciesDocumentsPartialUpdateResponses,
  type VotingPolicyVotingPoliciesDocumentsRetrieveData,
  type VotingPolicyVotingPoliciesDocumentsRetrieveResponse,
  type VotingPolicyVotingPoliciesDocumentsRetrieveResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsCreateData,
  type VotingPolicyVotingPoliciesVotingRecommendationsCreateResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsCreateResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsDestroyData,
  type VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsListData,
  type VotingPolicyVotingPoliciesVotingRecommendationsListResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsListResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateData,
  type VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponses,
  type VotingPolicyVotingPoliciesVotingRecommendationsRetrieveData,
  type VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponse,
  type VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponses,
  type VotingPolicyVotingRecommendationConfidenceScoresUpdateData,
  type VotingPolicyVotingRecommendationConfidenceScoresUpdateResponse,
  type VotingPolicyVotingRecommendationConfidenceScoresUpdateResponses,
  type VotingRecommendation,
  type VotingRecommendationConfidenceScore,
  type VotingRecommendationConfidenceScoreUpsertRequest,
  type VotingRecommendationCreateRequest,
  type VotingRecommendationWritable,
} from './types.gen'
